export enum FacebookEvents {
    FORM_SUBMIT_FACEBOOK_LEAD_EVENT = "FS",
    TYPEFORM_SUBMIT_FACEBOOK_EVENT = "FSTF",
    FORM_SUBMIT_FACEBOOK_SCHEDULED_EVENT = "ABW",
    FORM_SUBMIT_FACEBOOK_PAGE_VIEW_EVENT = "PageView",
    FORM_SUBMIT_FACEBOOK_FORM_VIEW_CONTENT = "ViewContent",
}

export enum GTMEvents {
    ULTRA_FORM_START = "ultraform_start",
    ULTRA_FORM_SCREEN_VIEW = "ultraform_screen_view",
    ULTRA_FORM_SCREEN_SUBMIT = "ultraform_screen_submit",
    GEOLOCATION_DETECTED = "geolocation_detected",
    CLINICS_SHOWN = "clinics_shown",
    CLINIC_SELECTED = "clinic_selected",
    LEGAL_MESSAGE_VIEWED = "legal_message_viewed",
    LEGAL_MESSAGE_OPENED = "legal_message_opened",
    LEAD_SAVED = "lead_saved",
    ULTRAFORM_ABANDON = "ultraform_abandon",
    ULTRAFORM_FLOW_LOADED = "ultraform_flow_loaded",
    FORM_SUBMIT_GTM_EVENT = "gtm.formSubmit",
    FORM_VIEWED_GTM_EVENT = "gtm.formViewed",
    TYPEFORM_VIEWED_GTM_EVENT = "gtm.typeformViewed",
    WIDGET_VIEWED_GTM_EVENT = "gtm.widgetViewed",
    WIDGET_DATE_TIME_SELECTED_GTM_EVENT = "gtm.widgetDateTimeSelected",
    WIDGET_BOOKING_SUBMITTED_GTM_EVENT = "gtm.widgetBookingSubmitted",
    WIDGET_BOOKING_RESCHEDULED_GTM_EVENT = "gtm.widgetBookingRescheduled",
    UNIVERSAL_LANDING_IN_EXPERIMENT_GTM_EVENT = "gtm.universalLandingInExperiment",
    CHANGE_COUNTRY_CODE_GTM_EVENT = "gtm.changeCountryCode",
    CHANGE_INPUT_COUNTRY_CODE_GTM_EVENT = "gtm.changeInputCountryCode",
    VIEW_AVAILABLE_SLOTS_GTM_EVENT = "gtm.viewAvailableSlots",
    SEARCH_ON_MAP_GTM_EVENT = "gtm.searchOnMap",
    CLICK_SUGGESTION_ON_MAP_GTM_EVENT = "gtm.clickSuggestionOnMap",
    EXPERIMENT_ACTIVATED = "gtm.experimentActivated",
    GROWTHBOOK_EXPERIMENT_VIEWED = "experiment_viewed",
    CITY_CHANGED_EVENT = "gtm.cityChanged",
    VIEW_AVAILABLE_DATES_GTM_EVENT = "gtm.viewAvailableDates",
    SMILE_VISION_PAGE_VIEWED = "page_viewed",
    SMILE_VISION_CTA_CLICKED = "sv_cta_clicked",
    SMILE_VISION_CTA_SECONDARY_CLICKED = "sv_cta_secondary_clicked",
}
